import React from 'react'
import rahul from './image/rahul.jpg'
import { Link } from 'react-router-dom'

function AboutMe() {
    return (
        <div>
            <div className="fluid">

                <div id='pic' className='row'>
                    <div className='col-1' style={{ width: "240px", height: "570px" }}>
                        <img id='p' src={rahul} alt='' style={{ width: "100%", objectFit: "cover", height: "570px" }}></img>
                    </div>

                    <div className='col-4'>
                        <h3 id='hhh'>AboutMe</h3>
                        <p id='pp'>Hi EveryOne  
                        My name is <span>RahulChaudhary</span> ,this is Bloging site, Like Social Media  Where u can Create your own account and Publiced Post, And you are Able to DELETE and UPDATE own Post Not able to do this with Other POST , You can LIke and Dislike Only !!!</p>
                        <button  className='btn btn bg-warning'><Link id='lll' to='/'>Home</Link></button>
                    </div>

                   
                </div>


            </div>
        </div>
    )
}

export default AboutMe
